
/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React, { Fragment } from 'react'
import moment from 'moment'
import InputBox from '../../components/InputBox'
import TextArea from '../../components/TextArea'
import CustomDatePicker from '../../components/DatePicker'
import ImageUpload from '../../components/ImageUpload'
import DropdownWithoutSearch from '../../components/DropdownWithoutSearch'
import ErrorMessage from '../../components/ErrorMessage'
import TopHeader from '../../components/TopHeader'
import { resetArrays } from "../../redux/MultiselectRowsConditionally"
import DeviceDropdownwithsearch from './Components/Dropdownwithsearch'
import { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams, useLocation, useSearchParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import GlobalContext from '../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import { useAddDeviceMutation,useEditDeviceMutation, useGetDeviceTemplateNameQuery, useViewDeviceQuery, useLazyGetDeviceTemplateDetailsQuery, useGetDeviceManufactureQuery ,useLazyViewDeviceQuery} from '../../features/deviceSlice'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import Loader from '../../components/Loader'
import { handleIsAPICall } from '../../redux/commonSlice'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import S3UploadHook from '../../CommonMethods/S3UploadHook'
import { CDN } from '../../config'
import { convertEpochToDateFormat } from "../../CommonMethods/DateConversion"
import Dropdown from '../../components/Dropdown'
import SearchEmptyScreen from '../../components/SearchEmptyScreen'
import { handleEditMessageSent,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import { broadcastForcedLogout } from '../../CommonMethods/authSession'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideAdminQuery} from '../../features/patientSlice'

export default function AddDevice({ edit }) {
    const { setToastmessage, UpdateCall, setUpdateCall, setToastErrorMessage, isSideBar,editSocket ,sendMessageToStartEditing,sendMessageToStopEditing } = useContext(GlobalContext)
    const { id } = useParams()
    const location = useLocation()
    const mainKey = 'device-images'
    const [skip, setSkip] = useState(true)
    const { data, isFetching, status } = useViewDeviceQuery(id, { skip: skip,refetchOnMountOrArgChange:true })
    const [addDevice] = useAddDeviceMutation();
    const { data: manufactureData, isFetching: manufactureFetching } = useGetDeviceManufactureQuery();
    const isFromEdit = location.state?.[1] || false; 
    const [nextTarget, setNextTarget] = useState('');
    const [trigger,result] = useLazyViewDeviceQuery()
    const [dataloading,setDataLoading] = useState(true)
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)


    // selected dropdown
    const [uploadImageLoader, setUpoadImageLoader] = useState(false)
    const [isDisableCancel,setIsDisableCancel]=useState(true)

    const [searchParams, setSearchParams] = useState({});
    const [templateListSearch, setTemplateListSearch] = useState({
    });
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsadmin, setQueryParamsadmin] = useState('')
    const userType=localStorage?.getItem('user_type')!==null?localStorage.getItem('user_type'):sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideAdminQuery(queryParamsadmin, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    
    
   
    useEffect(() => {
        if (edit) {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-edit-devices');
            } else {
                setQueryParamsadmin('type=admin-edit-devices');
            }
        } else {
            if (userType === 'corporate-user') {
                setQueryParamsadmin('type=corporate-add-devices');
            } else {
                setQueryParamsadmin('type=admin-add-devices');
            }
        }
    }, [userType,edit]);
      
    useEffect(() => {
        if (queryParamsadmin) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsadmin]);
    // device template name
    const  deviceTempateres= useGetDeviceTemplateNameQuery(new URLSearchParams(templateListSearch).toString(),  { refetchOnMountOrArgChange: true });

    // view dropdown template
    const [getTemplateDetails, { data: templateData, error, isLoading }] = useLazyGetDeviceTemplateDetailsQuery();
    const [editDevice] = useEditDeviceMutation()
    const reading_types = ['Blood Glucose', 'Blood Pressure', 'SPO2', 'Weight', 'Pulse', 'Temperature']
    const imageTypes = ['image/png', 'image/jpeg', 'image/jpg']
    const [deviceDetails, setDeviceDetails] = useState({
        "device_template": "",
        "reading_type": [],
        "model": "",
        'serial_number': '',
        "warranty_period": "",
        "purchase_date": "",
        "service_provider": "",
        "service_period": "",
        "service_activation_date": "",
        "original_location": "",
        "description": "",
        "image_url": "",
        "status": 'Active',
        "apiIdentifier":"",
        "device_manufacture":[],

    })
    const values = Object.values(deviceDetails);
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const [formatError, setformatError] = useState('')
    const [emptyField, setEmptyField] = useState(false)
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const dateformat = useSelector(state => state?.systemConfigData?.globalVariables?.date_format)
    const [emptyArea, setEmptyArea] = useState(false);
    const [loadingStatus, setLoadingStatus] = useState(false)
  
    const dispatch = useDispatch()
    // checkbox selection
    const handleSelectAll = (selectAllChecked) => {
        setIsDisableCancel(false)
        setDeviceDetails((prev) => {
            if (selectAllChecked) {
                // Add all elements to the array
                return {
                    ...prev,
                    reading_type: [...reading_types]
                };
            } else {
                // Remove all elements from the array
                return {
                    ...prev,
                    reading_type: []
                };
            }
        });
    }

    // clearall 
    const handleClear = () => {
        setDeviceDetails((prev)=>({
            ...prev,
            "reading_type": [],
        })
        )
    }
        
    // reading type
    const handleReadingTypeSelect = (selectedItem) => {
        setIsDisableCancel(false)
        setDeviceDetails((prev) => {
            // Check if the selected item is already in the array
            const isItemSelected = prev.reading_type.includes(selectedItem);

            // If the item is selected, remove it; otherwise, add it
            const updatedReadingType = isItemSelected
                ? prev.reading_type.filter(item => item !== selectedItem)
                : [...prev.reading_type, selectedItem];

            return {
                ...prev,
                reading_type: updatedReadingType
            };
        });
    }

    // for selcect date
    function handleSelectDate(id, date, dateString, termkey) {
        setIsDisableCancel(false)
        if (id === "purchase_date") {
            setDeviceDetails((prv) => ({
                ...prv,
                purchase_date: moment(dateString).format('MM-DD-YYYY'),
            }));
        }
        else {
            setDeviceDetails((prv) => ({
                ...prv,
                service_activation_date: moment(dateString).format('MM-DD-YYYY'),
            }));
        }

    }
    //    get the details for the template_name values in device template dropdown
    const handleDropdownDetails = async (id, option) => {
        setIsDisableCancel(false)
        setDeviceDetails((prv) => ({
            ...prv,
            device_template: option.template_name
        }))
        getTemplateDetails(option._id)
    }


    // device template search function

    const handleTemplateListSearch = (value) => {
        setTemplateListSearch((prevSearch) => {
            if (value !== '') {
                return {
                    ...prevSearch,
                    search: value,
                };
            } else {
            // Remove the search key from the state if the value is empty
                const { search, ...rest } = prevSearch;
                return rest;
            }
        });
      
    };
    useEffect(() => {
        if(templateData !== undefined){
            
            setDeviceDetails((prv) => ({
                ...prv,
                reading_type: templateData?.reading_type,
                device_manufacture: templateData?.manufacturer_name,
                model: templateData?.model,
                warranty_period: templateData?.warranty_period,
                purchase_date: templateData?.purchase_date,
                service_provider: templateData?.service_provider,
                service_period: templateData?.service_period,
                service_activation_date: templateData?.service_activation_date,
                original_location: templateData?.original_location,
                image_url: templateData?.image_url,
                description: templateData?.description,
                template_created_at:templateData?.created_at
                
               
            }))
            setSkip(true)
        }
    }, [templateData]);
     
    // get the template without refreshing the page
    useEffect(() => {
        deviceTempateres.refetch();
    }, []);

    /* The above code is a React useEffect hook that is being used to fetch template details based on the
  searchParams. It is triggered whenever the searchParams value changes. */
    useEffect(() => {
        getTemplateDetails(new URLSearchParams(searchParams)?.toString())
    }, [searchParams])
   

    function handleOnChangeUserDetails(id, option) {
        const fieldToUpdate = {
            device_template: "device_template",
            model: "model",
            serial_number: "serial_number",
            warranty_period: "warranty_period",
            purchase_date: "purchase_date",
            service_provider: "service_provider",
            service_period: "service_period",
            service_activation_date: "service_activation_date",
            original_location: "original_location",
            image_url: "image_url",
            description: "description",
            status:'status',
            apiIdentifier:'apiIdentifier',
            device_manufacture:'device_manufacture'
            
           
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid=true

        if (id === "warranty_period" || id==="service_period") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid=false
            }
        }
        if(!isValid){
            if (fieldToUpdate) {
                setDeviceDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }             
            return
        }
        if (fieldToUpdate) {
            setIsDisableCancel(false)
            if(fieldToUpdate==="value_added"||fieldToUpdate==="direct_billing"){
                setOrgDetails((prev) => ({
                    ...prev,
                    [fieldToUpdate]: !option,
                }));
            }
            setDeviceDetails((prev) => ({
                ...prev,
                [fieldToUpdate]: option,
            }));
        }

    }
    function handleCheckBox(id, option) {
        setIsDisableCancel(false)
        setDeviceDetails((prev) => ({
            ...prev,
            [id]: option,
        }));

    }
    // handle upload image
    async function handleUploadChange(e) {
        setIsDisableCancel(false)
        setUpoadImageLoader(true);
        setformatError('')
        const id = e.target.id
        const selectedFile = e.target.files[0];
        if (e.target.files) {
            if (!imageTypes.includes(e.target.files[0].type)) {
                setformatError(e.target.id);
                e.target.value = null
                setToastErrorMessage('The uploaded file does not meet the required file format or size. Please try again')
                setUpoadImageLoader(false)
                return;
            }
            if (selectedFile && selectedFile.size > 10 * 1024 * 1024) {
                setformatError(e.target.id);
                e.target.value = null
                setToastErrorMessage('Image must be in PNG/JPEG format Image size cannot exceed 10 MB')
                setUpoadImageLoader(false)
                return;
            }
            const file = e.target.files[0];
            let url = '';
            if (file.name && file.type) {
                url = await S3UploadHook(file, mainKey);
                setDeviceDetails((prv) => ({
                    ...prv,
                    [id]: url
                }))
                setUpoadImageLoader(false);
            }
        }
    }
    const handleRemoveImage = () => {
        setDeviceDetails((prv) => ({
            ...prv,
            image_url: ''
        }))
    }
    const handleAddDevice = async () => {
        setLoading(true)
        try {
            setLoading(true)

            let body = {
                "device_template": deviceDetails?.device_template,
                "reading_type": deviceDetails?.reading_type,
                "manufacturer_name": deviceDetails?.device_manufacture,
                "model": deviceDetails?.model,
                'serial_number': deviceDetails?.serial_number,
                "warranty_period": deviceDetails?.warranty_period,
                "purchase_date": deviceDetails.purchase_date !== "" ? moment(deviceDetails.purchase_date).format('YYYY-MM-DD') : '',
                "service_provider": deviceDetails?.service_provider,
                "service_period": deviceDetails?.service_period,
                "service_activation_date": deviceDetails?.service_activation_date !== "" ? moment(deviceDetails?.service_activation_date).format('YYYY-MM-DD') : '',
                "original_location": deviceDetails?.original_location,
                "description": deviceDetails?.description,
                "image_url": deviceDetails?.image_url,
                'status': deviceDetails?.status.replaceAll(" ", "-").toLowerCase(),
                'api_identifier':deviceDetails?.apiIdentifier?.trim(),
            } 
            if(!edit){
                body.template_created_at =deviceDetails?.device_template !== ''? templateData?.created_at.toString():''
            }
            if(edit  && deviceDetails?.device_template !== '' ){
                ( body.template_created_at = data?.template_created_at !==null ?data?.template_created_at.toString():data?.template_created_at )||(body.template_created_at = templateData?.created_at?.toString())
            }
            // edit device
            if (edit) {
                const editRes = await editDevice({ id, body })
                //dispatch(handleIsAPICall(true))
                if (editRes?.error?.data?.message) {
                    setConfirmationState(false)
                    setToastErrorMessage(editRes?.error?.data?.message)
                    setLoading(false)
                }
                else {
                    navigate(`/manage-devices/${id}`)
                    setToastmessage('Device updated successfully');
                    setLoading(false)
                    dispatch(resetArrays())
                }
            }
            else {
                const addRes = await addDevice(body)
                //dispatch(handleIsAPICall(true))
                if (addRes?.error?.data?.message) {
                    setConfirmationState(false)
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                }
                else {
                    navigate(`/manage-devices/${addRes?.data?.device_id}`)
                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                }
            }
        } catch (error) {
            setLoading(false);
            //dispatch(handleIsAPICall(true))
            setToastErrorMessage(error.message)
        }
    }

  
    useEffect(()=>{
        if(edit){
            setSkip(false) 
        } 
        if(id){
            trigger(id)      
        }       
    },[edit,id])

    useEffect(()=>{
        return(()=>{
       
            if(location?.state!==null||location?.state!==''){
         
                sendMessageToStopEditing()
            }
        })
       
    },[])

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    broadcastForcedLogout();
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showDuplicateSessionLogout', 'true');
                    setTimeout(() => {
                        window.location.reload();
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(() => {
        if(result!==undefined&&result?.data?.device_id!==undefined){
            dispatch(handleTargetUserEditId(result?.data?.device_id))
            if(edit&&!messageSent&&editSocket){
               
                sendMessageToStartEditing(result?.data?.device_id)
            
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-devices')
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this device`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            setDeviceDetails((prev) => ({
                ...prev,
                "device_template": result?.data?.device_template,
                "device_id": result?.data?.device_id,
                "reading_type": result?.data?.reading_type,
                "model": result?.data?.model,
                'serial_number': result?.data?.serial_number,
                "warranty_period": result?.data?.warranty_period,
                "purchase_date": result?.data?.purchase_date,
                "service_provider": result?.data?.service_provider,
                "service_period": result?.data?.service_period,
                "service_activation_date": result?.data?.service_activation_date,
                "original_location": result?.data?.original_location,
                "description": result?.data?.description,
                "image_url": result?.data?.image_url,
                'status':status,
                'patient_id':result?.data?.patient_id,
                'assigned_at':result?.data?.assigned_at,
                'initial_reading_timestamp':result?.data?.initial_reading_timestamp,
                'created_at':result?.data?.created_at,
                'template_created_at':result?.data?.template_created_at,
                'apiIdentifier':result?.data?.api_identifier,
                'device_manufacture':result?.data?.manufacturer_name,
                
            }))
            // status 
            let status = result?.data.status;
            // Check if the status is "out-of-service" and handle it separately
            if (status === "out-of-service") {
                status = "Out of Service";
            } else {
                // Capitalize the first letter of each word for other statuses
                status = status.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
            }
            setSkip(true)
        }
        return(()=>{
          
            if(((location.state===null || location.state==='')&&result?.data?.device_id!==undefined)){
                
                sendMessageToStopEditing(result?.data?.device_id)
            }  
        })
    }, [result]);

    const handleConformationClick = () => {
        setEmptyArea(false)
        
        setConfirmationState(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    const handleSubmit = () => {
        const hasEmptyFields = () => {
            let isFieldsEmpty = false
            if (
                deviceDetails.reading_type.length === 0 ||
                deviceDetails.serial_number?.trim() === "" ||
                deviceDetails.model?.trim() === "" ||
                deviceDetails.apiIdentifier?.trim() ===""||
                deviceDetails.device_manufacture.length === 0
            ) {
                isFieldsEmpty = true
            }
            return isFieldsEmpty
        };
        if (hasEmptyFields()) {
            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");
            return;
        } else {
            setConfirmationState(true)
        }
    }

    const handleCancel = () => {
        setDeviceDetails('');
        if (nextTarget === 'view') {
            navigate(`/manage-devices/${id}`);
        } else {
            navigate('/manage-devices');
        }
        // edit?navigate(`/manage-devices/${id}`):navigate('/manage-devices');
    }
    
    // handle cancel button
    const handleCancelBottom = () => {  
        const stateToPass = Array.isArray(location.state) ? '' : location.state;
        if (isDisableCancel && (isFromEdit===true)) {
            navigate(`/manage-devices/${id}`);
        } else if (isDisableCancel) {
            navigate('/manage-devices',{state:stateToPass});
        } else {
            setNextTarget(
                (isFromEdit===true)
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }    
        // const values = Object.values(deviceDetails);  
        // const isEmpty = values.every(value => !value);
        // if(isDisableCancel){
        //     navigate('/manage-devices'); 
        // }
        // if (!isEmpty) {
        //     setConfirmationStateCancel(true);
        // } else {     
        //     navigate('/manage-devices');
        // }   
    }


    const CreationTimestamp = deviceDetails?.template_created_at !== null
        ? convertEpochToDateFormat(deviceDetails.template_created_at, dateformat).toString()
        : '-';
    const redioButtonStatus = ["Active", "Retired", "Out of Service"]

    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={`Manage Device`} />
                {((edit && isFetching && status !== "fulfilled") || loadingStatus) ? <CustomOverLay Active text="Loading Device Details..." classKey={`absolute top-0 left-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> :status==="rejected"?<SearchEmptyScreen text={"No data found"} />: <>
                    <div className='bg-white rounded-lg py-[12px] pl-[30px] pr-[10px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='pr-7'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-devices" state={location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Device</h1>
                                        </Link>
                                        {isFromEdit===true &&<>
                                            <span className='mx-2'><img loading='lazy' decoding='async' src="/images/breadcrumb-icon.svg" alt="icon"/></span>
                                            <Link to={`/manage-devices/${location.state?.[2]}`}>
                                                <h1 className="text-sm font-normal text-[#52555D]">View Device</h1>
                                            </Link>
                                        </>}
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        <h1 className="text-sm font-normal text-[#008586]">{`${edit ? 'Edit ' : 'Add '}Device`}</h1>
                                        {
                                            userType !=='super-admin' &&
                                            <span   onClick={() => setHelpGuideModel(true)} className='ml-auto min-w-fit cursor-pointer'>
                                                <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                            </span> 
                                        }
                     
                                    </div>
                                    {isFromEdit===true ?
                                        <div onClick={handleCancelBottom} state={location.state} className=' items-center cursor-pointer min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Device</span>
                                        </div> :
                                        <div onClick={handleCancelBottom} state={location.state} className='flex cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg"  alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586]  ml-3'>Go back to Listing</span>
                                        </div>
                                    }
                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        {`${edit ? 'Edit ' : 'Add '}Device`}
                                    </h1>
                                    <p className='text-end pt-2 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className={`pr-5 h-customh16  overflow-x-hidden  scrollbar_gray overflow-y-auto bg-white`}>
                                    <div className="border  border-[#C5C9DA] rounded-sm xl:px-[58px] lg:px-[20px] py-[44px]  mb-4 flex w-full">
                                        <div className='w-[30%] mr-[24px] relative'>
                                            {deviceDetails.image_url === '' ? (
                                                <div className='absolute left-3 right-3 top-0'>
                                                    {uploadImageLoader ? (
                                                        <div className=' h-[250px] relative  border-2 border-dashed  border-[#972E4C] px-4 xl rounded-lg mt-3 '>
                                                            <div className='flex justify-center items-center mt-[90px]'>
                                                           
                                                                <div className="loader ease-linear rounded-full border-t-4 border-[#972E4C] h-12 w-12  spin-animation"></div>
                                                           
                                                            
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <ImageUpload
                                                            uploadImageLoader={uploadImageLoader}
                                                            handleUploadChange={handleUploadChange}
                                                            id='image_url'
                                                            mainkey={'device_template'}
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <div>
                                                    {deviceDetails.image_url !== '' && (
                                                        <div className="relative w-full border-2 border-dashed  border-[#972E4C] px-4 xl:py-8 py-4 rounded-lg mt-3">
                                                            <img src={`${CDN}${deviceDetails.image_url}`} className="w-[600px] xl:h-[200px] h-[150px]  rounded-lg" alt="img" />
                                                            <img
                                                                src="/images/cross.svg"
                                                                alt="icon"
                                                                className="absolute top-[40px] right-[20px] w-7 h-7 bg-[#C81720] rounded-full cursor-pointer"
                                                                onClick={() => handleRemoveImage()}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                        <div className='flex overflow-auto h-[500px] pb-10  scrollbar_purple flex-wrap items-center -mx-[18px] w-[70%]'>
                                            <div className={`${edit ? "xl:w-1/2 lg:w-full" : "w-full"}`}>
                                                <div className={`${edit ? "w-full" : "xl:w-1/2 lg:w-full"} xl:mb-[32px] mb-[20px] px-[18px]`}>
                                                    <DeviceDropdownwithsearch
                                                        label={"Device Template"}
                                                        id={`device_template`}
                                                        placeholder={"Select device template"}
                                                        value={deviceDetails?.device_template}
                                                        disabled={false}
                                                        options={deviceTempateres?.data?.data}
                                                        objKey={"template_name"}
                                                        deviceTempateres={deviceTempateres}
                                                        handleTemplateListSearch={handleTemplateListSearch}
                                                        handleOnChangeInput={handleDropdownDetails}
                                                        obj
                                                        templateListSearch={templateListSearch}

                                                    />
                                                </div>
                                            </div>
                                            {edit && <div className='xl:w-1/2 lg:w-full'>
                                                <div className='w-full  xl:mb-[32px] mb-[25px] px-[18px]'>
                                                    <InputBox
                                                        label={"ID"}
                                                        id={"id"}
                                                        data_testid={"id"}
                                                        htmlFor={"ID"}
                                                        disabled={edit === true ? true : false}
                                                        value={data?.device_id}
                                                    />
                                                </div>
                                            </div>
                                            }
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <DropdownWithoutSearch
                                                        label={"Reading Type*"}
                                                        id={`reading_type`}
                                                        data_testid={"select_all"}
                                                        placeholder={`${deviceDetails.reading_type.length === 0 ? "Select reading types" : `${deviceDetails.reading_type.length} Selected`}`}
                                                        disabled={false}
                                                        options={reading_types}
                                                        handleReadingTypeSelect={handleReadingTypeSelect}
                                                        deviceTemplateDetails={deviceDetails}
                                                        handleSelectAll={handleSelectAll}
                                                        emptyField={emptyField && deviceDetails?.reading_type?.length === 0}
                                                        handleClear={handleClear}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"API Identifier*"}
                                                        placeholder={"Enter API identifier"}
                                                        id={"apiIdentifier"}
                                                        data_testid={"API_Identifier"}
                                                        htmlFor={"apiIdentifier"}
                                                        value={deviceDetails.apiIdentifier}
                                                        emptyField={emptyField && deviceDetails?.apiIdentifier?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        maxLength={60}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <Dropdown
                                                        label={"Device Manufacturer*"}
                                                        id={`device_manufacture`}
                                                        device_manufacture={true}
                                                        placeholder={deviceDetails.device_manufacture?.length > 0 ? '' : 'Select device manufacturer'}
                                                        data_testid={"manufacturer_name"}
                                                        value={deviceDetails?.device_manufacture}
                                                        options={manufactureData?.data?.map(item => item.manufacturer_name)}
                                                        emptyField={emptyField&&deviceDetails.device_manufacture.length===0}
                                                        handleOnChangeInput={handleOnChangeUserDetails}                                                        
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        maxLength={30}
                                                        label={"Model*"}
                                                        placeholder={"Enter model"}
                                                        id={"model"}
                                                        data_testid={"model"}
                                                        htmlFor={"model"}
                                                        value={deviceDetails.model}
                                                        emptyField={emptyField && deviceDetails?.model?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        maxLength={30}
                                                        label={"Serial Number*"}
                                                        placeholder={"Enter serial number"}
                                                        id={"serial_number"}
                                                        data_testid={"serial_number"}
                                                        htmlFor={"serial_number"}
                                                        value={deviceDetails.serial_number}
                                                        emptyField={emptyField && deviceDetails?.serial_number?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            {/* <div className='w-1/2 px-[18px] mb-[35px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Device Manufacturer*"}
                                                        placeholder={"Enter device manufacturer"}
                                                        id={"manufacturer_name"}
                                                        data_testid={"manufacturer_name"}
                                                        htmlFor={"manufacturer_name"}
                                                        value={deviceDetails.manufacturer_name}
                                                        emptyField={emptyField && deviceDetails?.manufacturer_name?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div> */}
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                </div>
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='xl:w-[70%] w-full'>
                                                    <InputBox
                                                        label={"Warranty Period (Months)"}
                                                        placeholder={"Enter warranty period"}
                                                        id={"warranty_period"}
                                                        data_testid={"warranty_period"}
                                                        htmlFor={"warranty_period"}
                                                        value={deviceDetails.warranty_period}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='xl:w-1/3 w-1/2 px-[18px] mb-[32px]'>
                                                
                                                <CustomDatePicker
                                                    id={"purchase_date"}
                                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                                    format="MM/DD/YYYY"
                                                    placeholder={"Select Date"}
                                                    label={"Purchase Date"}
                                                    termkey={deviceDetails.purchase_date}
                                                    handleSelect={handleSelectDate}
                                                    imageClass={true}
                                                />
                                                
                                            </div>
                                            <div className='w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Service Provider"}
                                                        placeholder={"Enter service provider"}
                                                        id={"service_provider"}
                                                        data_testid={"service_provider"}
                                                        htmlFor={"service_provider"}
                                                        value={deviceDetails.service_provider}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='xl:w-1/3 w-1/2 px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Service Period (Months)"}
                                                        placeholder={"Enter service period"}
                                                        id={"service_period"}
                                                        data_testid={"service_period"}
                                                        htmlFor={"service_period"}
                                                        value={deviceDetails.service_period}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='xl:w-1/3 w-1/2 px-[18px] mb-[32px]'>
                                                <CustomDatePicker
                                                    id={"service_activation_date"}
                                                    classKey={'border border-[#C5C9DA]  rounded-lg px-3.5 py-[11px] text-base font-normal text-[#000B17] w-full placeholder:text-[#52555D] outline-none bg-white flex justify-between items-center'}
                                                    format="MM/DD/YYYY"
                                                    placeholder={"Select Date"}
                                                    label={"Service Activation Date"}
                                                    termkey={deviceDetails.service_activation_date}
                                                    handleSelect={handleSelectDate}
                                                    imageClass={true}
                                                />
                                            </div>
                                            <div className='w-1/2 ml-auto px-[18px] mb-[32px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Original Location"}
                                                        placeholder={"Enter original location"}
                                                        id={"original_location"}
                                                        data_testid={"original_location"}
                                                        htmlFor={"original_location"}
                                                        value={deviceDetails.original_location}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            {/* device status */}
                                            <div className='w-full px-[18px] mb-[35px]'>
                                                <p className='text-sm font-semibold text-[#000000] pb-1.5'>Device Status</p>
                                                <div className='flex items-center'>
                                                    {redioButtonStatus.map((item) =>
                                                        (<div className="p-2" key={item}>
                                                            <div className="relative custom-radioBlue flex items-center">
                                                                <input id={item} data_testid={"status"} type="radio" name="default-radio" checked={deviceDetails?.status === item} onChange={() => { handleCheckBox("status", item) }} />
                                                                <label htmlFor={item} className="text-base font-normal text-[#000] pl-8 w-full cursor-pointer">
                                                                    {item}
                                                                </label>
                                                            </div>
                                                        </div>))}
                                                </div>
                                            </div>
                                            {edit && <>
                                                <div className='w-1/2  mb-[32px] px-[18px]'>
                                                    <InputBox
                                                        label={"Patient ID"}
                                                        id={"patient_id"}
                                                        data_testid={"patient_id"}
                                                        htmlFor={"patient_id"}
                                                        disabled={edit === true ? true : false}
                                                        value={data?.patient_id!== "" ? data?.patient_id: '-'}
                                                    />
                                                </div>
                                                <div className='w-1/2  mb-[32px] px-[18px]'>
                                                    <InputBox
                                                        label={"Assigned "}
                                                        id={"assigned "}
                                                        data_testid={"assigned "}
                                                        htmlFor={"assigned "}
                                                        disabled={edit === true ? true : false}
                                                        value={data?.assigned_at!== "" ? convertEpochToDateFormat(data?.assigned_at, dateformat).toString(): '-'}
                                                    />
                                                </div>
                                                <div className='w-1/2  mb-[32px] px-[18px]'>
                                                    <InputBox
                                                        label={"Initial Reading Timestamp"}
                                                        id={"initial_reading_timestamp"}
                                                        data_testid={"initial_reading_timestamp"}
                                                        htmlFor={"initial_reading_timestamp"}
                                                        disabled={edit === true ? true : false}
                                                        value={data?.initial_reading_timestamp!== "" ? convertEpochToDateFormat(data?.initial_reading_timestamp, dateformat).toString(): '-'}
                                                    />
                                                </div>
                                                <div className='w-1/2  mb-[32px] px-[18px]'>
                                                   
                                                    <InputBox
                                                        label={"Profile Creation Timestamp"}
                                                        id={"profile_creation_timestamp"}
                                                        data_testid={"profile_creation_timestamp"}
                                                        htmlFor={"profile_creation_timestamp"}
                                                        disabled={edit === true ? true : false}
                                                        value={CreationTimestamp}
                                                        
                                                    />
                                                </div>
                                            </>
                                            }
                                            <div className='w-full px-[18px] '>
                                                <div className='w-full h-[130px] '>
                                                    <TextArea
                                                        maxLength={300}
                                                        label={"Description"}
                                                        placeholder={"Enter description here..."}
                                                        id={"description"}
                                                        data_testid={"description"}
                                                        htmlFor={"description"}
                                                        value={deviceDetails.description}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex justify-end pr-5'>
                                    <div>
                                        <button type='button'
                                            id="cancel"
                                            onClick={() => handleCancelBottom()}
                                            // disabled={isDisableCancel}
                                            className={`px-4 py-2.5 mr-5 text-lg font-semibold text-[#972E4C] disabled:opacity-50 border border-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
                                            bg-[#fff] hover:bg-[#fff] focus:bg-[#fff]`}>
                                            {"Cancel"}
                                        </button>
                                        <button type='button'
                                            id="update"
                                            data-testid="add-device-btn"
                                            onClick={handleSubmit}
                                            className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px]
                                              bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                            {`${edit ? 'Update' : 'Submit'}`}

                                        </button>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </>}
                {confirmationState &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleAddDevice}
                                handleClose={handleConformationClick}
                                data-testid="confirm-btn"
                                disabled={loading}
                                tittle={`${edit ? 'Update Device' : 'Add Device'}`}
                                message={`Are you sure you want to  ${edit ? 'update' : 'add'} this device?`}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {confirmationStateCancel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                buttonName={true && 'Yes'}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )
}
